<template>
	<div class="server-role" v-show="visable" @click.stop="close()">
		<div class="server-role-box" @click.stop="serverVisable=false;roleVisable=false">
			<div class="title">

				<img class="sign decorate" src="../../assets/img/home/decorate-left.png" />
				&nbsp;&nbsp;角色&nbsp;&nbsp;
				<img class="sign decorate" src="../../assets/img/home/decorate-right.png" />
			</div>
			<div class="body">
				<!-- 				<div class="cell">
					<span class="label">区服&nbsp;&nbsp;&nbsp; </span>
					<div class="input-box">
						<div class="input" @click.stop="serverVisable=true"><input disabled v-model="form.serverName" /></div>
						<div class="select-list" v-show="serverVisable&&serverList.length>0">
							<div class="select-item" v-for="(item ,index) in serverList" :key="index">
								<span @click.stop="form.serverId=item.id">{{item.name}}</span>
							</div>
						</div>
					</div>
				</div> -->
				<div class="cell">
					<span class="label">角色&nbsp;&nbsp;&nbsp; </span>
					<div class="input-box">
						<div class="input" @click.stop="roleVisable=true">
							<input disabled v-model="form.roleName" placeholder="请选择角色" />
						</div>
						<div class="select-list" v-show="roleVisable&&roleList.length>0">
							<div class="select-item" v-for="(item ,index) in roleList" :key="index">
								<span @click.stop="form=item;roleVisable=false">{{item.serverName}}-{{item.roleName}}</span>
							</div>
						</div>
					</div>
				</div>

			</div>
			<div class="foot">
				<div class="submit" @click="submit()">确 定</div>

			</div>
		</div>
	</div>
</template>

<script>
	import store from '@/store'
	export default {
		name: "ServerRole",
		data() {
			return {
				form: {
					serverId: null,
					serverName: null,
					roleId: null,
					roleName: null,
				},
				serverVisable: true,
				roleVisable: false,
				serverList: [{
					name: 'asrgae'
				}, {
					name: 'asrgae'
				}, {
					name: 'asrgae'
				}],
				roleList: [],
				visable: false
			};
		},
		created() {

		},
		computed: {},
		methods: {
			show(callBack) {
				this.visable = true
				document.body.appendChild(this.$el)
				this.submitCallBack = callBack
				this.getServerRoleList()
			},
			close() {
				this.visable = false
				document.body.removeChild(this.$el)
			},
			submitCallBack() {},
			async submit() {
				this.close()
				this.submitCallBack(this.form)
			},
			async getServerRoleList() {
				let res = await store.dispatch('getServerRoleList', {})
				if (this.$Api.ok(res)) {
					if (res[0].data.data.length <= 0) {
						return this.$Toast.show('暂无角色请预下载并创建角色')
					}
					this.roleList = res[0].data.data
				}

			}
		},
	};
</script>
<style scoped>
	input {
		background: none;
		outline: none;
		border: none;
		width: 100%;
	}

	.server-role {
		height: 100vh;
		width: 100vw;
		position: absolute;
		top: 0;
		left: 0;
		background-color: rgba(0, 0, 0, 0.6);
		display: flex;
		align-items: center;
		justify-content: center;
		text-align: center;
	}

	.server-role-box {
		border-radius: 6px;
		width: 80%;
		margin: 0 auto;
		overflow: hidden;

	}

	.title {
		background-color: #ffffff;
		color: #686e3f;
		padding: 12px;
		font-size: 16px;
	}

	.decorate {
		width: 20%;
	}

	.logo {
		width: 140px;
	}

	.close-btn {
		width: 20px;
		float: right;
	}

	.body {
		background-color: #efe8c2;
		padding: 12px;
	}


	.foot {
		background-color: #ffffff;
		color: #686e3f;
		padding: 16px;
	}

	.submit {
		background-color: #90ba89;
		width: 40%;
		color: white;
		border-radius: 50px;
		margin: 0 auto;
		padding: 6px;
	}

	.cell {
		display: flex;
		padding: 4px 8px;
	}

	.cell .input-box {
		flex: 1;
		background-color: #ffffff;
		border-radius: 60px;
		text-align: left;
		display: flex;
		justify-content: flex-start;
		padding: 4px 12px;
	}

	.cell .input-box img {
		width: 16px;
		vertical-align: middle;
	}

	.cell .label {
		line-height: 18px;
		height: 18px;
		padding: 4px 12px;
		color: #686e3f;
	}

	.cell .input-box .input {
		vertical-align: middle;
		border: none;
		flex: 1;
		padding: 2px 6px;
		display: block;
	}

	.code {
		width: auto;
		display: inline-block;
		background-color: #dcce6b;
		border-radius: 60px;
		color: #ffffff;
		line-height: 28px;
		vertical-align: middle;
		text-align: center;
		margin-left: 10px;
		padding: 0 10px;
		font-size: 12px;
	}


	.select-list {

		position: absolute;
		margin-top: 26px;
		width: 44%;
		z-index: 9;
		max-height: 200px;
	}

	.select-item {
		width: 100%;
		padding: 4px 8px;
		width: 100%;
		font-size: 16px;
		background-color: #ffffff;
		box-shadow: 0 2px 12px 0 rgb(0, 0, 0, 0.3);
	}
</style>
